exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-point-box[data-v-5612fd74]{background-color:#fff}.list-title[data-v-5612fd74]{gap:24px}.list-number[data-v-5612fd74]{width:48px;height:48px;background:#025253}svg g[data-v-5612fd74]{fill:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5612fd74","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/MainPointsComponent.vue
// module id = a9el
// module chunks = 0